import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import {
  FigureMode,
  getFigureNotesMode,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/common/figure-mode';
import {
  detailsModalCommonHorizontalPadding,
  detailsModalCommonVerticalPadding,
} from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/common/styles';
import { ImpactSpecificFigureBoxes } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/comparisons';
import { BoxesProps } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/figure-boxes';
import { SingleImpactInfoBoxMonetaryFigureBoxes } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/monetary/monetary-figure-boxes';
import { ComparisonFigureNotes } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/notes/comparison-notes';
import { MonetaryFigureNotes } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/notes/monetary-notes';
import { ValueChainFigureNotes } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/notes/value-chain-figure-notes';
import { TopValueChain } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/top-value-chain';
import styled from 'styled-components';

export function FigureBoxesMobile(props: BoxesProps) {
  const { comparisonBoxCount, valueChainBoxCount, monetaryBoxCount, totalBoxCount } = props;
  const context = useNetImpactLensContext();
  const [valence, impact] = [context?.state.valence, context?.state.impact];

  if (!impact || !valence) {
    return <></>;
  }

  const notesMode = getFigureNotesMode(impact, valence);
  const showComparisonFigureNotes = notesMode === FigureMode.DEFAULT || notesMode === FigureMode.ONLY_COMPARISON_NOTES;
  const showMonetaryFigureNotes = notesMode === FigureMode.DEFAULT || notesMode === FigureMode.ONLY_MONETARY_NOTES;

  return (
    <Root>
      <FigureAndExplanationPart>
        <BoxWrap style={{ flexBasis: `${(comparisonBoxCount / totalBoxCount) * 100}%` }}>
          <ImpactSpecificFigureBoxes />
          {showComparisonFigureNotes && (
            <NotesWrap>
              <ComparisonFigureNotes />
            </NotesWrap>
          )}
        </BoxWrap>
        <BoxWrap style={{ flexBasis: `${(monetaryBoxCount / totalBoxCount) * 100}%` }}>
          <SingleImpactInfoBoxMonetaryFigureBoxes />
          {showMonetaryFigureNotes && (
            <NotesWrap>
              <MonetaryFigureNotes />
            </NotesWrap>
          )}
        </BoxWrap>
        <BoxWrap style={{ flexBasis: `${(valueChainBoxCount / totalBoxCount) * 100}%` }}>
          <TopValueChain />
        </BoxWrap>
        <NotesWrap>
          <ValueChainFigureNotes />
        </NotesWrap>
      </FigureAndExplanationPart>
    </Root>
  );
}

const Root = styled.div`
  ${getTextStyle({ size: 'xxs' })}
  width: 100%;
`;

const FigureAndExplanationPart = styled.div`
  display: block;
`;

const BoxWrap = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  border-bottom: 3px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
`;

const NotesWrap = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  ${detailsModalCommonVerticalPadding};
  ${detailsModalCommonHorizontalPadding};
  color: ${BouColor.TOOL_TEXT_DARKER_GRAY};
  line-height: 1.3;
  font-style: italic;
`;
